import React, { Fragment } from "react";
import * as Component from "./components";

export default () => {
  return (
    <Fragment>
      <Component.Brands />
      <Component.Categories />
      <Component.Distributors />
      <Component.Productss />
      <Component.Units />
    </Fragment>
  );
};
